import type { FC, ReactNode } from 'react';
import React from 'react';

import type { FILTERS_NAMES } from '@src/constants/filters';
import { useIsGoogleSearch } from '@src/reducers/metadata';

import type { RenderActionsProps } from '../../types';

import { FullDealEntryPointDefault } from './variants/FullDealEntryPointDefault/FullDealEntryPointDefault';
import { FullDealEntryPointForGoogle } from './variants/FullDealEntryPointForGoogle/FullDealEntryPointForGoogle';

export interface FullDealEntryPointProps {
  isHiddenBorder?: boolean;
  heading?: string;

  isLanding?: boolean;
  highlightOffer?: boolean;

  onChange?: (key: FILTERS_NAMES, value: number) => void;
  renderActions?: (props: RenderActionsProps) => ReactNode;
}

export const FullDealEntryPoint: FC<FullDealEntryPointProps> = (props: FullDealEntryPointProps) => {
  const isUserFromGoogleSearch = useIsGoogleSearch();

  const FullDealEntryPointComponent = isUserFromGoogleSearch ? FullDealEntryPointForGoogle : FullDealEntryPointDefault;

  return <FullDealEntryPointComponent {...props} />;
};
